module.exports = __webpack_public_path__ + "media/images/contar3-10494bf3c60c0562986063e7a787a692.png";